// extracted by mini-css-extract-plugin
export default {"pageLayout":"Clients_pageLayout__8Z1nZ"};